var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 250,
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#0B2F60;}\n\t.st1{fill:#6369EB;}\n\t.st2{fill:#9862F0;}\n\t.st3{fill:#D05BF5;}\n\t.st4{fill:#FFFFFF;}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m313.36,109.64l0,19.5l-22.82,0l0,69.01l-20.19,0l0,-69.01l-22.82,0l0,-19.5l65.83,0z",
    id: "svg_4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m341.29,126.09c-2.21,2.21 -4.98,3.32 -8.02,3.32c-3.18,0 -5.81,-1.11 -8.02,-3.32c-2.21,-2.21 -3.32,-4.98 -3.32,-8.02c0,-3.18 1.11,-5.81 3.32,-8.02c2.21,-2.21 4.98,-3.32 8.02,-3.32c3.18,0 5.81,1.11 8.02,3.32c2.21,2.21 3.32,4.98 3.32,8.02c0,3.04 -1.11,5.81 -3.32,8.02zm-17.56,72.19l0,-63.2l18.95,0l0,63.2l-18.95,0z",
    id: "svg_5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m389.14,200.08c-9.68,0 -17.56,-3.18 -23.92,-9.68c-6.36,-6.36 -9.54,-14.38 -9.54,-23.79c0,-9.4 3.18,-17.42 9.54,-23.79c6.36,-6.36 14.38,-9.68 23.92,-9.68c6.08,0 11.62,1.52 16.73,4.43c5.12,2.9 8.99,6.91 11.89,11.75l-16.59,9.68c-2.21,-4.7 -6.36,-7.05 -12.31,-7.05c-4.15,0 -7.61,1.38 -10.23,4.15c-2.77,2.77 -4.01,6.22 -4.01,10.51c0,4.29 1.38,7.88 4.01,10.51c2.77,2.77 6.08,4.15 10.23,4.15c5.95,0 10.1,-2.35 12.31,-7.05l16.59,9.54c-2.77,4.98 -6.64,8.99 -11.75,11.89c-5.12,2.9 -10.65,4.43 -16.87,4.43z",
    id: "svg_6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m488.16,198.28l-21.44,0l-20.19,-27.93l0,27.93l-18.95,0l0,-88.51l18.95,0l0,52.97l18.95,-27.66l22.13,0l-22.96,31.67l23.51,31.53z",
    id: "svg_7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m510.42,174.22c2.21,5.95 7.19,8.85 15.21,8.85c5.12,0 9.13,-1.66 12.17,-4.84l15.21,8.71c-6.22,8.71 -15.49,13 -27.52,13c-10.65,0 -19.08,-3.18 -25.45,-9.54c-6.36,-6.36 -9.54,-14.24 -9.54,-23.92c0,-9.54 3.18,-17.42 9.4,-23.79c6.22,-6.36 14.38,-9.54 24.2,-9.54c9.13,0 16.87,3.18 22.96,9.54c6.08,6.36 9.13,14.38 9.13,23.79c0,2.77 -0.28,5.26 -0.69,7.61l-45.08,0l0,0.14zm-0.41,-14.11l27.24,0c-1.8,-6.64 -6.36,-9.96 -13.41,-9.96c-7.33,-0.14 -11.89,3.18 -13.83,9.96z",
    id: "svg_8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m604.18,153.2l-13,0l0,22.4c0,2.49 0.97,4.15 3.04,4.84c2.07,0.69 5.39,0.83 9.96,0.69l0,17.15c-12.03,1.24 -20.47,0.14 -25.03,-3.46c-4.7,-3.6 -6.91,-9.96 -6.91,-19.22l0,-22.4l-10.1,0l0,-18.25l10.1,0l0,-12.03l18.95,-5.67l0,17.7l13,0l0,18.25z",
    id: "svg_9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m687.99,133.42c7.05,0 12.86,2.35 17.15,6.91c4.43,4.56 6.64,10.79 6.64,18.67l0,39.27l-11.06,0l0,-39c0,-4.84 -1.24,-8.71 -3.73,-11.34c-2.49,-2.77 -5.95,-4.01 -10.1,-4.01c-4.7,0 -8.44,1.52 -11.34,4.7c-2.77,3.18 -4.29,8.02 -4.29,14.52l0,35.13l-11.06,0l0,-39c0,-4.84 -1.24,-8.71 -3.6,-11.34c-2.35,-2.77 -5.67,-4.01 -9.82,-4.01c-4.7,0 -8.44,1.66 -11.62,4.84c-3.04,3.18 -4.56,8.02 -4.56,14.38l0,35.13l-11.06,0l0,-63.2l11.06,0l0,8.44c4.29,-6.78 10.65,-10.1 18.81,-10.1c8.57,0 14.66,3.6 18.53,10.79c4.56,-7.33 11.2,-10.79 20.05,-10.79z",
    id: "svg_10"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m736.94,171.73c1.11,5.67 3.73,10.1 7.74,13.14c4.15,3.18 9.13,4.7 15.07,4.7c8.3,0 14.38,-3.04 18.25,-9.27l9.4,5.26c-6.22,9.54 -15.49,14.24 -27.8,14.24c-10.1,0 -18.25,-3.18 -24.48,-9.4c-6.22,-6.22 -9.4,-14.24 -9.4,-23.79c0,-9.54 3.04,-17.42 9.27,-23.79c6.22,-6.36 14.11,-9.54 23.92,-9.54c9.27,0 16.87,3.32 22.68,9.82c5.81,6.5 8.85,14.38 8.85,23.65c0,1.66 -0.14,3.18 -0.41,4.98l-53.1,0zm21.99,-27.93c-5.95,0 -10.79,1.66 -14.66,4.98c-3.87,3.32 -6.22,7.74 -7.19,13.28l42.18,0c-0.97,-5.95 -3.32,-10.51 -7.05,-13.69c-3.87,-3.04 -8.3,-4.56 -13.28,-4.56z",
    id: "svg_11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m837.62,145.59l-16.87,0l0,34.3c0,3.18 0.55,5.39 1.8,6.64c1.24,1.24 3.04,1.94 5.67,2.07c2.49,0 5.67,0 9.4,-0.14l0,9.82c-9.68,1.24 -16.59,0.55 -21.16,-2.35c-4.43,-2.77 -6.64,-8.16 -6.64,-16.04l0,-34.3l-12.58,0l0,-10.65l12.58,0l0,-14.38l11.06,-3.32l0,17.7l16.87,0l0,10.65l-0.14,0z",
    id: "svg_12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m864.31,145.59c3.6,-7.88 10.23,-11.75 19.78,-11.75l0,11.48c-5.39,-0.28 -10.1,1.24 -13.97,4.29c-3.87,3.18 -5.81,8.16 -5.81,15.07l0,33.47l-11.06,0l0,-63.2l11.06,0l0,10.65z",
    id: "svg_13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m902.48,123.47c-2.07,0 -3.87,-0.69 -5.26,-2.21c-1.38,-1.38 -2.21,-3.18 -2.21,-5.26c0,-2.07 0.69,-3.73 2.21,-5.26c1.38,-1.52 3.18,-2.21 5.26,-2.21c2.07,0 3.73,0.69 5.26,2.21c1.38,1.52 2.21,3.18 2.21,5.26c0,2.07 -0.69,3.73 -2.21,5.26c-1.52,1.52 -3.32,2.21 -5.26,2.21zm-5.67,74.82l0,-63.2l11.06,0l0,63.2l-11.06,0z",
    id: "svg_14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m956.55,199.94c-9.54,0 -17.42,-3.18 -23.79,-9.54c-6.36,-6.36 -9.54,-14.24 -9.54,-23.79c0,-9.4 3.18,-17.29 9.54,-23.65c6.36,-6.36 14.24,-9.54 23.79,-9.54c6.22,0 11.89,1.52 16.87,4.43c4.98,3.04 8.71,7.05 11.06,12.03l-9.27,5.26c-1.66,-3.32 -4.01,-6.08 -7.47,-8.16c-3.32,-2.07 -7.05,-3.04 -11.34,-3.04c-6.36,0 -11.62,2.21 -15.9,6.5c-4.29,4.29 -6.36,9.68 -6.36,16.04c0,6.36 2.07,11.62 6.36,15.9c4.29,4.29 9.54,6.5 15.9,6.5c4.15,0 8.02,-0.97 11.34,-2.9c3.32,-1.94 5.95,-4.7 7.74,-8.02l9.4,5.39c-2.77,4.98 -6.64,8.99 -11.62,11.89c-4.98,3.18 -10.51,4.7 -16.73,4.7z",
    id: "svg_15"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svg_16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m79.92,95.39l-39.14,0c-2.49,0 -4.43,-2.07 -4.43,-4.43l0,-7.61l2.07,-0.55c2.21,-0.69 3.73,-3.04 3.73,-5.81c0,-2.77 -1.52,-5.26 -3.73,-5.95l-2.07,-0.55l0,-7.61c0,-2.49 2.07,-4.43 4.43,-4.43l39.14,0c2.49,0 4.43,2.07 4.43,4.43l0,7.61l-2.07,0.55c-2.21,0.69 -3.73,3.04 -3.73,5.81c0,2.77 1.52,5.12 3.73,5.81l2.07,0.55l0,7.61c0.14,2.49 -1.94,4.56 -4.43,4.56zm-37.89,-5.81l36.79,0l0,-2.49c-3.46,-1.94 -5.67,-5.95 -5.67,-10.37c0,-4.43 2.21,-8.44 5.67,-10.51l0,-2.49l-36.79,0l0,2.49c3.46,1.94 5.67,5.95 5.67,10.51c0,4.43 -2.21,8.44 -5.67,10.37l0,2.49z",
    id: "svg_18"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m60.42,120.15c-23.92,0 -43.42,-19.5 -43.42,-43.42c0,-23.92 19.5,-43.42 43.42,-43.42c23.92,0 43.42,19.5 43.42,43.42c-0.14,23.92 -19.5,43.42 -43.42,43.42zm0,-81.04c-20.74,0 -37.75,16.87 -37.75,37.75c0,20.74 16.87,37.75 37.75,37.75c20.74,0 37.75,-16.87 37.75,-37.75c-0.14,-20.88 -17.01,-37.75 -37.75,-37.75z",
    id: "svg_20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m66.51,74.79l-12.17,0c-1.52,0 -2.9,-1.24 -2.9,-2.9c0,-1.52 1.24,-2.9 2.9,-2.9l12.17,0c1.52,0 2.9,1.24 2.9,2.9c-0.14,1.52 -1.38,2.9 -2.9,2.9z",
    id: "svg_23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m66.51,84.47l-12.17,0c-1.52,0 -2.9,-1.24 -2.9,-2.9c0,-1.52 1.24,-2.9 2.9,-2.9l12.17,0c1.52,0 2.9,1.24 2.9,2.9c-0.14,1.66 -1.38,2.9 -2.9,2.9z",
    id: "svg_25"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svg_26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m164.69,214.88c-8.57,0 -15.49,-6.91 -15.49,-15.49l0,-93.07c0,-8.57 6.91,-15.49 15.49,-15.49c8.57,0 15.49,6.91 15.49,15.49l0,93.07c0,8.57 -6.91,15.49 -15.49,15.49z",
    id: "svg_28"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svg_29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m116.02,214.88c-8.57,0 -15.49,-6.91 -15.49,-15.49l0,-62.09c0,-8.57 6.91,-15.49 15.49,-15.49s15.49,6.91 15.49,15.49l0,62.09c0.14,8.57 -6.91,15.49 -15.49,15.49z",
    id: "svg_31"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svg_32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m67.34,214.88c-8.57,0 -15.49,-6.91 -15.49,-15.49l0,-38.58c0,-8.57 6.91,-15.49 15.49,-15.49s15.49,6.91 15.49,15.49l0,38.58c0,8.57 -6.91,15.49 -15.49,15.49z",
    id: "svg_34"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.b5eca1dfbc0bdee36f2a9c2ecd3f8a05.svg";
export { ForwardRef as ReactComponent };